class App {
    static get WD() {return [ _("Su"), _("Mo"), _("Tu"), _("We"), _("Th"), _("Fr"), _("Sa") ];}
	static get WKD() {return [_('Sun'), _('Mon'), _('Tue'), _('Wed'), _('Thu'), _('Fri'), _('Sat')];}
    static get WEEKDAY() {return [
        _("Sunday"),
        _("Monday"),
        _("Tuesday"),
        _("Wednesday"),
        _("Thursday"),
        _("Friday"),
        _("Saturday"),
        _("Selected days")
    ];}
	static get WEEK() {return [_('First'), _('Second'), _('Third'), _('Fourth'), _('Last')];}
	static get MTH() {return [_('Jan'), _('Feb'), _('Mar'), _('Apr'), _('May'), _('Jun'), _('Jul'), _('Aug'), _('Sep'), _('Oct'), _('Nov'), _('Dec')];}
	static get MONTH() {return [
		_('January'), 
		_('February'), 
		_('March'), 
		_('April'), 
		_('May'), 
		_('June'), 
		_('July'), 
		_('August'), 
		_('September'), 
		_('October'), 
		_('November'), 
		_('December')
	];}

	static append(elem, content) {
        if (elem === null) {
            elem = content;
        }
        else if (typeof elem === 'string') {
            elem += content;
        }
        else if (Array.isArray(elem)) {
            if (Array.isArray(content)){
                return elem.concat(content);
            }
            else {
                elem.push(content);
            }
        }
        return elem;
    }
	
	static onlyNumbers(event) {
		if (!event instanceof KeyboardEvent || !event.key) return null;

		let kc = event.key;
		let normalOp = [
			'Backspace',
			'Tab',
			'Enter',
			'Escape',
			'Delete',
			'ArrowRight',
			'ArrowLeft',
			'Shift'
		];

		if (normalOp.indexOf(kc) !== -1) return false;
		
		if (event.metaKey || event.ctrlKey) return false;

		event.preventDefault();
		return kc == ' ' || isNaN(kc) ? false : kc;
	}

	static numbersOnly(ev) {
		
		let kc = ev.keyCode;
		let ok = [8, 46, 37, 39, 13, 27];
		for (let i = 0; i < ok.length; i++)
			if (kc === ok[i]) return;
		if (kc < 48 || kc > 57)
			ev.preventDefault();
	}
}
